import { SidebarItemProps } from "../types/global";
import {
  URL_METHODIST_MAIN,
  URL_METHODIST_REPORTS,
  URL_TEACHER_CHECK_MYSELF,
  URL_TEACHER_MAIN,
  URL_TEACHER_REPORTS,
  PROFILE_SETTINGS,
  PROFILE_OVERVIEW,
} from "./page_urls";

export const methodistSidebarItems: SidebarItemProps[] = [
  {
    path: URL_METHODIST_MAIN,
    name: "Bosh sahifa",
    icon: "home-3",
  },
  {
    path: URL_METHODIST_REPORTS,
    name: "Shikoyatlar",
    icon: "question",
  },
  {
    blockTitle: "Hisob",
    path: PROFILE_OVERVIEW,
    name: "Kabinet",
    icon: "user-square",
  },
  {
    path: PROFILE_SETTINGS,
    name: "Sozlamalar",
    icon: "gear",
  },
];

export const teacherSidebarItems: SidebarItemProps[] = [
  {
    path: URL_TEACHER_MAIN,
    name: "Bosh sahifa",
    icon: "home-3",
  },
  {
    path: URL_TEACHER_CHECK_MYSELF,
    name: "O'zingizni sinang",
    icon: "medal-star",
  },
  {
    path: URL_TEACHER_REPORTS,
    name: "Shikoyatlar",
    icon: "question",
  },
  {
    blockTitle: "Hisob",
    path: PROFILE_OVERVIEW,
    name: "Kabinet",
    icon: "user-square",
  },
  {
    path: PROFILE_SETTINGS,
    name: "Sozlamalar",
    icon: "gear",
  },
];
